function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { emphasize } from '@material-ui/core/styles/colorManipulator';

var hex2rgba = function hex2rgba(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var _hex$match$map = hex.match(/\w\w/g).map(function (x) {
    return parseInt(x, 16);
  }),
      _hex$match$map2 = _slicedToArray(_hex$match$map, 3),
      r = _hex$match$map2[0],
      g = _hex$match$map2[1],
      b = _hex$match$map2[2];

  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
};

export var styles = function styles(theme) {
  return {
    root: {
      flexGrow: 1,
      height: 250
    },
    input: {
      display: 'flex'
    },
    multiValueContainer: {
      paddingLeft: '0px !important'
    },
    inputMultilineDense: {
      paddingTop: '0px !important',
      paddingBottom: '0px !important',
      height: '40px'
    },
    inputNormal: {
      display: 'flex',
      paddingTop: "".concat(theme.spacing(0.5), "px !important"),
      paddingBottom: "".concat(theme.spacing(0.5), "px !important"),
      // Material v4 inserts a fixed height to InputBase breaking the select web style
      // See: https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/InputBase/InputBase.js#L81
      height: '1.75em'
    },
    dummyWrapper: {
      display: 'none'
    },
    valueContainer: {
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      flexGrow: 1
    },
    chip: {
      margin: "".concat(theme.spacing(0.5), "px ").concat(theme.spacing(0.25), "px")
    },
    chipFocused: {
      backgroundColor: emphasize(theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
    },
    noOptionsMessage: {
      padding: "".concat(theme.spacing(1), "px ").concat(theme.spacing(2), "px")
    },
    singleValue: {
      fontSize: 16
    },
    placeholder: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    paper: {
      position: 'absolute',
      zIndex: 1,
      left: 0,
      width: '100%'
    },
    divider: {
      height: theme.spacing(2)
    },
    select: {// nothing here
    },
    flex: {
      display: 'flex'
    },
    dropdownIndicator: {
      cursor: 'pointer !important'
    },
    separatorIndicator: {
      margin: "0px !important"
    },
    body1Option: {
      width: '100%',
      whiteSpace: 'normal',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    noZIndex: {
      zIndex: 'unset'
    },
    '@global': {
      '*::-webkit-scrollbar': {
        width: '6px'
      },
      '*::-webkit-scrollbar-thumb': {
        borderRadius: '12px',
        backgroundColor: hex2rgba(theme.palette.primary.main, 0.5)
      },
      '*::-webkit-scrollbar-thumb:hover': {
        backgroundColor: theme.palette.primary.main
      }
    }
  };
};